import { Mutation } from 'vuex';
import { IModuleState } from './types';
import { navTreeBuild } from '@/store/materials/nav/util';

// 导航树
export const setNavTrees: Mutation<IModuleState> = (state, payload) => {
  state.navTrees.system = navTreeBuild(payload.systemRaw, []);
  state.navTrees.org = navTreeBuild(payload.orgRaw, []);
  state.navTrees.loading = !!payload.loading;
};

// 图片列表
export const setMatImgList: Mutation<IModuleState> = (state, payload) => {
  state.imgList.data = payload.data;
  state.imgList.pageSize = payload.pageSize;
  state.imgList.pageNum = payload.pageNum;
  state.imgList.total = payload.total;
  state.imgList.loading = !!payload.loading;
};

export const setConditions: Mutation<IModuleState> = (state, payload) => {
  state.conditions = (payload || []).map((item: any, i: number) => ({ ...item, id: i + 1 }));
};

export const setOnlyMobileAsset: Mutation<IModuleState> = (state, payload) => {
  state.onlyMobileAsset = payload;
};
